import { render, staticRenderFns } from "./m_m_addr_list.vue?vue&type=template&id=09b51bea&scoped=true"
import script from "./m_m_addr_list.vue?vue&type=script&lang=js"
export * from "./m_m_addr_list.vue?vue&type=script&lang=js"
import style0 from "./m_m_addr_list.vue?vue&type=style&index=0&id=09b51bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b51bea",
  null
  
)

export default component.exports